import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { quiz } from '../data/village-data';

const TREE_IMG = "https://customer-assets.emergentagent.com/job_alchemy-village/artifacts/bc4plj5c_Alchemy%20Village%20Tree%20of%20Life.png";

export default function ManifestorCard({ name, archetypeKey, onClose }) {
  const cardRef = useRef(null);
  const [downloading, setDownloading] = useState(false);
  const [showMeaning, setShowMeaning] = useState(false);
  const archetype = archetypeKey ? quiz.archetypes[archetypeKey] : null;

  const downloadCard = async () => {
    if (!cardRef.current || downloading) return;
    setDownloading(true);
    try {
      const canvas = await html2canvas(cardRef.current, {
        scale: 2,
        backgroundColor: '#0F0A19',
        allowTaint: true,
        useCORS: true,
        logging: false,
      });
      const link = document.createElement('a');
      link.download = `village-manifestor-${name?.replace(/\s+/g, '-').toLowerCase() || 'card'}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (err) {
      console.error('Download failed:', err);
    }
    setDownloading(false);
  };

  const shareCard = async () => {
    if (!cardRef.current) return;
    try {
      const canvas = await html2canvas(cardRef.current, {
        scale: 2,
        backgroundColor: '#0F0A19',
        allowTaint: true,
        useCORS: true,
        logging: false,
      });
      canvas.toBlob(async (blob) => {
        if (navigator.share && blob) {
          const file = new File([blob], 'village-manifestor.png', { type: 'image/png' });
          await navigator.share({
            title: 'I AM a Village Manifestor',
            text: `I AM a Village Manifestor! I crossed the Bridge to BECOMING Me! My archetype: ${archetype?.name || ''}. Discover yours at thealchemyvillage.com`,
            files: [file],
          });
        } else {
          downloadCard();
        }
      }, 'image/png');
    } catch {
      downloadCard();
    }
  };

  if (showMeaning && archetype) {
    return (
      <div className="manifestor-card-overlay" data-testid="archetype-meaning-overlay">
        <div className="archetype-meaning-modal">
          <h2 className="archetype-meaning-heading">The Archetypes of Becoming</h2>
          <h1 className="archetype-meaning-name">{archetype.name}</h1>
          <p className="archetype-meaning-tagline">{archetype.tagline}</p>
          <div className="archetype-meaning-body">
            {archetype.description.split('\n\n').map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="archetype-meaning-gifts">
            <p className="archetype-gift"><strong>Your gift</strong> is {archetype.gift.charAt(0).toLowerCase() + archetype.gift.slice(1)}</p>
            <p className="archetype-challenge"><strong>Your challenge</strong> is {archetype.challenge.charAt(0).toLowerCase() + archetype.challenge.slice(1)}</p>
          </div>
          <p className="archetype-meaning-closing">{archetype.closing}</p>
          <div className="archetype-meaning-actions">
            <button className="village-btn village-btn--secondary" onClick={() => setShowMeaning(false)} data-testid="back-to-card-btn">
              Back to Card
            </button>
            {onClose && (
              <button className="mc-close" onClick={onClose} data-testid="close-meaning-btn">
                Continue
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="manifestor-card-overlay" data-testid="manifestor-card-overlay">
      <div className="manifestor-card-modal">
        {/* The actual card for capture */}
        <div ref={cardRef} className="manifestor-card" data-testid="manifestor-card">
          <div className="mc-bg" style={{ backgroundImage: `url(${TREE_IMG})` }} />
          <div className="mc-gradient" />
          <div className="mc-content">
            <p className="mc-iam">I AM a</p>
            <h1 className="mc-title">Village Manifestor</h1>
            <div className="mc-divider" />
            <p className="mc-name">{name}</p>
            {archetype && <p className="mc-archetype-large">{archetype.name}</p>}
            {archetype && <p className="mc-tagline-type">{archetype.tagline}</p>}
            <p className="mc-tagline">I crossed the Bridge to BECOMING Me!</p>
            <div className="mc-footer">
              <span className="mc-brand">The Alchemy Village</span>
              <span className="mc-url">thealchemyvillage.com</span>
            </div>
          </div>
        </div>

        {/* Actions outside the card (not captured) */}
        <div className="mc-actions">
          <button
            data-testid="download-card-btn"
            className="village-btn village-btn--primary"
            onClick={downloadCard}
            disabled={downloading}
          >
            {downloading ? 'Creating...' : 'Download Card'}
          </button>
          <button
            data-testid="share-card-btn"
            className="village-btn village-btn--secondary"
            onClick={shareCard}
          >
            Share
          </button>
          {archetype && (
            <button
              data-testid="read-meaning-btn"
              className="mc-meaning-link"
              onClick={() => setShowMeaning(true)}
            >
              Read Your Archetype Meaning
            </button>
          )}
          {onClose && (
            <button
              data-testid="close-card-btn"
              className="mc-close"
              onClick={onClose}
            >
              Continue
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
